import { IS_DE_LANG_ENV } from '../../../../config/env';

export const extendContainer = () => ({
    tabletLarge: {
        gridColumnGap: '1.2rem',
    },
});

export const textContainer = ({ theme: { colors } }) => ({
    background: colors.bgGrey,
    padding: '2rem',
    tablet: {
        paddingLeft: '2.75rem',
        paddingTop: '3.5rem',
        paddingBottom: '6.0625rem',
    },
});

export const extendTitle = () => ({
    marginTop: 0,
    marginBottom: '2rem',
    fontSize: '1.75rem',

    tabletLarge: {
        maxWidth: '27.5rem',
    },

    desktop1200: {
        maxWidth: IS_DE_LANG_ENV ? '39.5rem' : '37.5rem',
    },
});

export const link = {
    textDecoration: 'none',
};

export const extendLinkTitle = {
    title: ({ theme: { colors } }) => ({
        fontSize: '1.75rem',

        transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) color 0.3s',
        willChange: 'color',

        maxWidth: '86.1875rem',
        marginBottom: '0',
        marginTop: '0',
        lineHeight: 1.25,

        ':hover': {
            color: colors.fuchsia,
        },
    }),
};

export const imageContainer = () => ({
    tabletLarge: {
        marginLeft: '-1.5rem',
    },
});
